import {AppThunk} from '../../index';
import {loginStepSlice} from '../../../reducers/runtime/loginStep';
import {LoginState} from '../../../../shared/models/login/loginStep';

export const setRuntimeLoginStepState =
  (value: LoginState): AppThunk =>
  (dispatch) => {
    dispatch(loginStepSlice.actions.setLoginStep(value));
  };
